import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CaptainSubscriptionsService } from 'src/app/captain-subscriptions.service';
import { FilterService, SingleSearchableDropdown } from 'src/app/filter.service';
import { Pagination, Table, TableData, TableDataTypes } from 'src/app/shared/types';

@Component({
    selector: 'app-captain-availablesubscription',
    templateUrl: './captain-availablesubscription.component.html'
})
export class CaptainAvailableSubscriptionComponent implements OnInit {
    @Input() captainId: string;
    @Output() toggleHeaders: EventEmitter<any> = new EventEmitter();
    @Input() captainDetailsToggleableHeaders: string[];
    captainAvailableSubscriptions: Table;
    dataLoaded = false;
    availableSubscriptions: any[] = [];
    filtersApplied: { subscriptionType?: string; } = {};
    subscriptionTypeFilters = ['CASHBACK', 'REGULAR', 'POSTPAID'];

    constructor(
        public captainSubscriptionsService: CaptainSubscriptionsService,
        private filterService: FilterService,
    ) { }

    ngOnInit() {
        this.declareTable();
    }

    declareTable() {
        const selectedHeader = this.captainDetailsToggleableHeaders.indexOf('Available Subscriptions');
        this.captainAvailableSubscriptions = new Table({
            toggleableHeaders: this.captainDetailsToggleableHeaders,
            headers: {
                amount: 'Amount (INR)',
                planType: 'Plan Type',
                ruleTypeandperiod: 'Rule Type\n Period',
                planStatus: 'Plan Status',
                consumption: 'Consumption',
                city: 'City',
                id: 'Subscription Rule ID',
            },
            pagination: new Pagination(0, 10, 30, [10, 15, 20], 0, true),
            selectedHeader: selectedHeader >= 0 ? selectedHeader : 14,
            defaultError: 'No available subscriptions found',
            appliedFilters: this.filtersApplied,
            filterComponents: [
                new SingleSearchableDropdown({
                    key: 'subscriptionType',
                    title: 'Subscription Type',
                    values: this.subscriptionTypeFilters,
                    default: '',
                    placeholder: 'Search subscription type',
                } as any)
            ],
            onFilter: () => {
                const subscriptionType = this.filterService.appliedFilters.subscriptionType;
                this.filtersApplied = {
                    subscriptionType: subscriptionType || ''
                };
                this.captainAvailableSubscriptions.filterCount = this.filtersApplied.subscriptionType ? 1 : 0;
                this.captainAvailableSubscriptions.appliedFilters = this.filtersApplied;
                this.filterAvailableSubscriptions();
            },
            onRefresh: () => {
                this.captainAvailableSubscriptions = null;
                this.ngOnInit();
            },
            data: []
        });
        this.getSubscriptions();
    }

    async getSubscriptions(pageNumber = 1, perPage = 10) {
        this.dataLoaded = false;
        this.captainSubscriptionsService.getCaptainSubscriptions(this.captainId, pageNumber, perPage)
            .then((res) => {
                this.availableSubscriptions = res && res.availableSubscriptions ? res.availableSubscriptions : [];
                this.filterAvailableSubscriptions();
                this.dataLoaded = true;
            }).catch(err => {
                console.log(err);
                this.dataLoaded = true;
            });
    }

    private filterAvailableSubscriptions() {
        const selectedFilter = ((this.filtersApplied && this.filtersApplied.subscriptionType) || '').toUpperCase();
        const filteredSubscriptions = this.availableSubscriptions.filter((subscription) => {
            if (!selectedFilter) {
                return true;
            }
            return (subscription.subscriptionType || '').toUpperCase() === selectedFilter;
        });
        this.captainAvailableSubscriptions.pagination.count = filteredSubscriptions.length;
        this.captainAvailableSubscriptions.data = filteredSubscriptions.map((subscription) => this.mapAvailableRow(subscription));
    }

    private mapAvailableRow(subscription: any) {
        const progress = subscription.progress || [];
        const period = subscription.period;
        const typeLabel = (subscription.subscriptionType || 'NA').toUpperCase();
        const planTypeClass = typeLabel === 'CASHBACK' ? 'whiteSpacePre text-success' : undefined;
        const periodLine = period && period.value != null && period.type ? `${period.value} ${period.type} validity` : '';
        const progressLine = progress.length ? progress.map((p: any) => `${p.type} validity`).join(', ') : 'NA';
        const rulesText = (subscription.rules || []).map(r => `${r.operator} ${r.value} ${r.type == "percent" ? "% commission" : "commission"}`).join('\n') || 'NA';
        const consumptionText = progress.length ? progress.map((p: any) => {
                if (p.totalRides != null) {
                    return `${p.current} / ${p.target} ${p.type} (rides ${p.totalRides})`;
                }
                return `${p.current} / ${p.target} ${p.type}`;
            }).join('\n') : 'NA';

        return {
            amount: this.createTableData(subscription.amount != null && subscription.amount !== '' ? String(subscription.amount) : 'NA'),
            planType: this.createTableData(`${typeLabel}\n${progressLine}\n${rulesText}`, planTypeClass),
            ruleTypeandperiod: this.createTableData(subscription.ruleType + '\n' + periodLine),
            planStatus: subscription.planStatus,
            consumption: this.createTableData(consumptionText),
            city: this.createTableData((subscription.cityName || 'NA')),
            id: this.createTableData(String(subscription.id != null ? subscription.id : '-'), 'text-overflow-unset'),
        };
    }

    dateString(epoch: number): string {
        return new Date(epoch * 1000).toLocaleString();
    }

    createTableData(value: string, className?: string, type?: TableDataTypes, flag = false, hoverData = null) {
        return new TableData({
            data: value,
            type: type ? type : TableDataTypes.DATA,
            flag: flag,
            hoverData: hoverData,
            className: className ? className + ' cursor-pointer' : 'cursor-pointer whiteSpacePre',
        });
    }

    changeInHeader(header: string) {
        this.toggleHeaders.emit(header);
    }

    onPaginationChange(event: { pageNo: number, perPage: number; }) {
        this.getSubscriptions((event.pageNo + 1), event.perPage);
    }
}
